import OrderLayerBlueprint from "components/blueprints/OrderLayerBlueprint";
import OrderMainNav from "components/navigations/OrderNavs/OrderMainNav";
import React from "react";

function OrderNotificationsPage() {
  return (
    <div className="bg-gray-100 py-2 min-h-screen">
      <OrderMainNav />
      <div className="container mx-auto my-6">OrderNotificationsPage</div>
    </div>
  );
}

export default OrderLayerBlueprint(OrderNotificationsPage);
